module.exports = __webpack_public_path__ + "a99ebddcf6de28e55c72ef624bcd39fe.pdf";